var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"form",staticClass:"form-element",attrs:{"id":_vm.element.id},on:{"submit":_vm.onFormSubmit}},_vm._l((_vm.elements),function(item,index){return _c(((item.type) + "Element"),{key:index,tag:"component",attrs:{"value":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }